// XL Feet: when a visitor switches away from the tab, the tab title
// alternates between the page title and "Baby Come Back!" until they return.
(function () {
  var AWAY_TITLE = 'Baby Come Back!';
  var originalTitle = document.title;
  var timer = null;

  function setAway() {
    if (timer) return;
    var showAway = true;
    document.title = AWAY_TITLE;
    timer = setInterval(function () {
      showAway = !showAway;
      document.title = showAway ? AWAY_TITLE : originalTitle;
    }, 1600);
  }

  function setBack() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    document.title = originalTitle;
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      setAway();
    } else {
      setBack();
    }
  });
})();
